import React from 'react';
import { Card } from '@/components/ui/card';
import { Shield } from 'lucide-react';
import SiteBanner from '../../components/SiteBanner';
import { useAdminForgotPassword } from './AdminForgotPassword/useAdminForgotPassword';
import EmailStep from './AdminForgotPassword/EmailStep';
import OtpStep from './AdminForgotPassword/OtpStep';
import NewPasswordStep from './AdminForgotPassword/NewPasswordStep';

export default function AdminForgotPassword() {
  const f = useAdminForgotPassword();

  return (
    <div className="admin-container flex flex-col min-h-screen bg-gradient-to-br from-emerald-50 to-emerald-100">
      <SiteBanner scope="admin" />
      <div className="flex-1 flex items-center justify-center p-6">
        <Card className="p-8 max-w-md w-full shadow-2xl" data-testid="admin-forgot-password-page">
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-emerald-600 to-emerald-500 rounded-full flex items-center justify-center shadow-lg">
            <Shield className="w-8 h-8 text-white" />
          </div>
        </div>
        <h1 className="text-3xl font-black font-heading uppercase text-center mb-2 text-emerald-700">
          Reset Password
        </h1>
        <p className="text-center text-emerald-600 mb-6 font-semibold">SmashZone Admin</p>

        {f.step === 'email' && (
          <EmailStep
            email={f.email}
            setEmail={f.setEmail}
            loading={f.loading}
            onSubmit={f.submitEmail}
            onBack={f.backToLogin}
          />
        )}
        {f.step === 'otp' && (
          <OtpStep
            email={f.email}
            otp={f.otp}
            setOtp={f.setOtp}
            loading={f.loading}
            resendCooldown={f.resendCooldown}
            resendCount={f.resendCount}
            onSubmit={f.submitOtp}
            onResend={f.resendOtp}
            onBack={f.backToLogin}
          />
        )}
        {f.step === 'password' && (
          <NewPasswordStep
            newPassword={f.newPassword}
            setNewPassword={f.setNewPassword}
            confirmPassword={f.confirmPassword}
            setConfirmPassword={f.setConfirmPassword}
            loading={f.loading}
            onSubmit={f.submitNewPassword}
          />
        )}
      </Card>
      </div>
    </div>
  );
}
